module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/databg.png?d8140d60a329a80cf6961b56c0d59299";